import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import AssetImage from './AssetImage';
import * as userDataActions from '../../../actions/userDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import {ASSET_CONFIG} from '../../../models/dialogModels';
import * as animationHelper from "../../../helpers/animationHelper";

class SecondaryImage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            imageClass: props.imageClass,
            imageStyles: props.imageStyles,
            status: objectConstants.STATUS_NOT_STARTED,
            locale: appHelper.getLocalData(this.props.screenObject),
            showProgressionButton: false,
            image: {},
            screenStatus: "",
            checkComplete: false,
            continue_label: appHelper.getLocaleString("continue_label")

        };
        this.getAssets = this.getAssets.bind(this);
        this.setClass = this.setClass.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.onCloseAssetDialog = this.onCloseAssetDialog.bind(this);
        this.launchAsset = this.launchAsset.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.getImageClass = this.getImageClass.bind(this);
        this.getImageStyles = this.getImageStyles.bind(this);
        this.allowDiagramZoom = this.allowDiagramZoom.bind(this);
        this.showDiagramTitle = this.showDiagramTitle.bind(this);
        this.showDiagramDescription = this.showDiagramDescription.bind(this);
    }

    componentDidMount() {
        this.getAssets();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.lang !== nextProps.lang) {
            let image = appHelper.getImageAsset(this.state.screenObject);
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                image: appHelper.isDefined(image.locale) ? appHelper.getLocalData(image) : image,
                continue_label: appHelper.getLocaleString("continue_label")
            });
        }
        if (this.state.imageClass !== nextProps.imageClass) {
            this.setState({imageClass: nextProps.imageClass});
        }

        if (this.state.imageStyles !== nextProps.imageStyles) {
            this.setState({imageStyles: Object.assign({}, nextProps.imageStyles)});
        }
    }

    componentDidUpdate() {

    }

    getAssets() {
        let image = appHelper.getImageAsset(this.state.screenObject);
        this.setState({image: appHelper.isDefined(image.locale) ? appHelper.getLocalData(image) : image});

    }

    scrollToTop() {

    }


    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    setClass() {
        if (this.state.status === objectConstants.STATUS_COMPLETE) {
            return "complete";
        } else {
            return "not-started";
        }
    }


    onCloseAssetDialog(viewed) {
        /*let objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.resource.asset_id);
        if(objectUserData.status !== objectConstants.STATUS_COMPLETE && viewed) {
            this.updateResourceObjectResult();
        }*/
    }

    launchAsset() {
        let childComponenents = [];
        let config = Object.assign({}, ASSET_CONFIG,
            {
                title: this.state.locale.label,
                onClose: this.onCloseAssetDialog,
                showCloseBtn: false,
                theme: "dialog-asset-image",
                sourceId: `image_btn_${this.state.screenObject.asset_id}`
            }
        );

        for (let i = 0; i < config.childComponents.length; i++) {
            let child = config.childComponents[i];
            child = Object.assign({}, child, {
                childComponent: AssetImage,
                componentProps: Object.assign({}, {
                    screenObject: this.state.screenObject,
                    callbacks: {}

                })
            });

            childComponenents = dataHelper.immutablePush(childComponenents, child);
        }
        config = Object.assign({}, config, {
            childComponents: childComponenents
        });
        if (this.allowDiagramZoom()) {
            this.props.actions.setNewAssetDialog(config);
        }
    }

    setKeyboardAccessibility(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            event.stopPropagation();
            this.launchAsset();
        }
    }

    getImageClass() {
        return appHelper.isDefined(this.state.imageClass) ? this.state.imageClass : "";
    }

    getImageStyles() {
        return appHelper.isDefined(this.state.imageStyles) ? this.state.imageStyles : {};
    }

    allowDiagramZoom() {

        let returnVal = appHelper.isDefined(this.state.screenObject.allow_diagram_zoom) ? this.state.screenObject.allow_diagram_zoom : true;
        return returnVal;

    }

    showDiagramTitle() {
        return appHelper.isDefined(this.state.screenObject.show_diagram_title) ? this.state.screenObject.show_diagram_title : true;
    }

    showDiagramDescription() {
        return appHelper.isDefined(this.state.screenObject.show_diagram_description) ? this.state.screenObject.show_diagram_description : true;
    }

    render() {
        return (
            <div className="object-container">
                <div className={`image-object`} onClick={this.launchAsset}
                     id={`image_btn_${this.state.screenObject.asset_id}`} onKeyDown={this.setKeyboardAccessibility}
                     role="link" tabIndex={0} style={this.getImageStyles()}>
                    <div className={`asset-image-wrapper ${this.getImageClass()}`}>
                        <img src={this.getImagePath(this.state.image.src)} alt={this.state.locale.label}
                             id={appHelper.isDefined(this.props.id) ? this.props.id : `image_${this.state.screenObject.asset_id}`}/>
                        {this.allowDiagramZoom()
                            ?
                            <div className="image-zoom"/>
                            :
                            null
                        }
                    </div>
                    {this.showDiagramTitle() || this.showDiagramDescription() ?
                        <div className="asset-content">
                            {
                                appHelper.isDefined(this.state.locale.label) && this.state.locale.label.length > 0 && this.showDiagramTitle()
                                    ?

                                    <div className="title" dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                                    :
                                    null
                            }
                            {
                                appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description !== "<p><br/></p>" && this.state.locale.description.length > 0 && this.showDiagramDescription()
                                    ?
                                    <div className="desc-text"
                                         dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                    :
                                    null
                            }
                        </div>
                        :
                        null
                    }
                </div>
                {this.state.showProgressionButton
                    ? <Button label={this.state.continue_label}
                              id={`${this.state.screenObject}_button`}
                              onClick={this.onProgressionBtnClicked}/>
                    : null
                }
            </div>

        );
    }
}

SecondaryImage.propTypes = {
    screenObject: PropTypes.object.isRequired,
    imageClass: PropTypes.string,
    imageStyles: PropTypes.object,
    id: PropTypes.string,
    index: PropTypes.number,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

SecondaryImage.contextTypes = {
    router: PropTypes.object
};

/*
* <ParagraphText screenObject={this.state.screenObject}
                                   ref={`${this.state.screenObject.asset_id}_paragraph`}
                                   id={`${this.state.screenObject}_description`}
                                   class_name="document-description"
                                   objectKey={`description`}/>*/

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, userDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SecondaryImage);



/** WEBPACK FOOTER **
 ** ./src/components/objects/image/SecondaryImage.js
 **/